import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { GroupsOfGroupEffects } from './groups-of-group.effects';
import { groupsOfGroupReducer } from './groups-of-group.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('groupsOfGroups', groupsOfGroupReducer),
    EffectsModule.forFeature([GroupsOfGroupEffects]),
  ],
  providers: [],
})
export class GroupsOfGroupStoreModule {}
